export const ExternalLink = ({
  size = 16,
  color = 'currentColor',
  ...rest
}: {
  size?: number;
  color?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" {...rest}>
    <path
      fill={color}
      d="M11.239.605a.467.467 0 0 1 .656.656l-.032.036-4.666 4.666a.467.467 0 1 1-.66-.66L11.203.637l.036-.032Z"
    />
    <path
      fill={color}
      d="M11.067 5.633v-4.2h-4.2a.467.467 0 1 1 0-.933h4.666l.048.002A.467.467 0 0 1 12 .967v4.666a.467.467 0 1 1-.933 0ZM0 10.5V4.1a2 2 0 0 1 2-2h3.2a.4.4 0 0 1 0 .8H2A1.2 1.2 0 0 0 .8 4.1v6.4A1.2 1.2 0 0 0 2 11.7h6.4a1.2 1.2 0 0 0 1.2-1.2V7.3a.4.4 0 0 1 .8 0v3.2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z"
    />
  </svg>
);
